<template>
    <div class="nav-tabs nav-tabs--services nav-tabs--padding | u-margin-left-flush">
        <div :class="{ 'is-active': step == 1 }" class="nav-tabs__item" data-nav-tab="dns">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <router-link
                    class="link-tabs"
                    :to="{ name: 'dnsOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 1 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.dns') }}
                    </span>
                    <img class="u-display--none-desk" src="@/assets/feather-icons/dns.svg" />
                </router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 2 }" class="nav-tabs__item" data-nav-tab="domain">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <router-link
                    class="link-tabs"
                    :to="{ name: 'domainOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 2 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.domain-name') }}
                    </span>
                    <img class="u-display--none-desk" src="@/assets/feather-icons/globe.svg" />
                </router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 3 }" class="nav-tabs__item" data-nav-tab="hosting">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <router-link
                    class="link-tabs"
                    :to="{ name: 'hostingOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 3 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.hosting') }}
                    </span>
                    <img class="u-display--none-desk" src="@/assets/feather-icons/database.svg" />
                </router-link>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        step: Number,
        domain: {
            type: String,
            required: true
        },
        service: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
